import { createContext } from 'react';
import { MachineConfContextType } from 'types/machineConf/machineConfType';

const MachineConfContext = createContext<MachineConfContextType>({
  leftRight: '',
});
export default MachineConfContext;
